import React from "react";
import { View, ActivityIndicator, Text } from "react-native";

export function InitialLoading() {
  return (
    <View style={{
      flex: 1,
      justifyContent: 'center',
      backgroundColor: 'black'
    }} >
      <ActivityIndicator
        size="large" color="white"
      />
      <Text
      style={{
        color: 'white',
        marginTop: 10,
        fontSize: 18,
        fontWeight: 'bold',
        textAlign: "center",
        textAlignVertical: "center",
      }}
      >
        Carregando...
      </Text>
    </View>
  )
}